// =============================================================
// VALIDATION & FORMATTING UTILITIES
// =============================================================

/**
 * Validates full name: minimum 2 characters, letters and spaces only
 */
export function validateName(name: string): { isValid: boolean; error?: string } {
  const trimmed = name.trim()
  if (!trimmed) {
    return { isValid: false, error: 'Full name is required' }
  }
  if (trimmed.length < 2) {
    return { isValid: false, error: 'Name must be at least 2 characters' }
  }
  // Allow letters, spaces, dots, hyphens
  const nameRegex = /^[a-zA-Z\s.'-]+$/
  if (!nameRegex.test(trimmed)) {
    return { isValid: false, error: 'Name should only contain letters and standard characters' }
  }
  return { isValid: true }
}

/**
 * Validates Indian 10-digit mobile number starting with 6, 7, 8, or 9
 */
export function validateMobileNumber(mobile: string): { isValid: boolean; error?: string } {
  const digits = mobile.replace(/\D/g, '')
  if (!digits) {
    return { isValid: false, error: 'Mobile number is required' }
  }
  if (digits.length !== 10) {
    return { isValid: false, error: 'Please enter a valid 10-digit mobile number' }
  }
  if (!/^[6-9]/.test(digits)) {
    return { isValid: false, error: 'Mobile number must start with 6, 7, 8, or 9' }
  }
  return { isValid: true }
}

/**
 * Validates OTP: numeric, 4 to 6 digits
 */
export function validateOtp(otp: string): { isValid: boolean; error?: string } {
  const trimmed = otp.trim()
  if (!trimmed) {
    return { isValid: false, error: 'Please enter the verification code (OTP)' }
  }
  if (!/^\d{4,6}$/.test(trimmed)) {
    return { isValid: false, error: 'OTP must be 4 to 6 digits' }
  }
  return { isValid: true }
}

/**
 * Mask mobile number for privacy (e.g. +91 98••• ••210)
 */
export function maskMobileNumber(mobile: string): string {
  const clean = mobile.replace(/\D/g, '')
  if (clean.length === 10) {
    return `+91 ${clean.slice(0, 2)}•••• ••${clean.slice(8)}`
  }
  return mobile
}

